// ChatBotContext.js
import React from 'react';

export const ChatBotContext = React.createContext({
  openChat: () => {},   // default no-op
   clicked  : false,
  setClicked: () => {},
});